// auto generated by command enum:ts
enum Role {
  User = 0,
  Moderator = 1,
  Admin = 2,
}
export default Role